/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */
import { connect } from "react-redux";
import Component from "@tunnel-components/@sharded/menu/component";
import * as React from "react";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";
import * as Paths from "@tunnel-enums/index";
// import * as Paths from '@tunnel-enums/index';
// import UIfx from "uifx";
// import { Howl } from "howler";

import {
  IncidentstmdLoadedActionCreator,
  CheckIncidentsIsNotQualifyActionCreator,
  NotificationLoadedActionCreator,
  IncidentstmdLoadedAction,
} from "@tunnel-store/index";
import SetInterval from "set-interval";
/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @name  hideShowmenu
 * @name  onChange
 * @name  onEndDateChange
 * @name  componentWillReceiveProps
 * @name  render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);

    /**
     * @namespace
     * @property { object }     state
     * @property { array }      state.menu
     * @property { array }      state.supermenu
     * @property { array }      state.tmdmenu
     * @property { boolean }    state.adminmenu
     */
    this.state = {
      menu: [true, false, false, false, false],
      supermenu: [true, false, false, false, false, false],
      tmdmenu: [true, false, false],
      adminmenu: [true, false],
      bip: false,
      tmdnumbersincident: 0,
      incidentnotifications: 0,
    };
    // references to

    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onmenu = this.onmenu.bind(this);
    this.onsupermenu = this.onsupermenu.bind(this);
    this.ontmdmenu = this.ontmdmenu.bind(this);
    this.onadminmenu = this.onadminmenu.bind(this);
    this.onslidemenu = this.onslidemenu.bind(this);
  }
  /**
   * @method
   * @name  onmenu
   * @description ""
   */
  public onmenu = (index: number) => (event: any): void => {
    const menu: any = [];
    const Leng: number = this.state.menu.length;

    for (let i = 0; i < Leng; i++) {
      menu.push(false);
    }
    menu[index] = true;

    localStorage.setItem("menus", menu);

    if (index === 0 || index === 1) {
      localStorage.removeItem("supermenu");
      localStorage.removeItem("tmdmenu");
      localStorage.removeItem("adminmenu");
    }
    if (index === 2) {
      localStorage.removeItem("tmdmenu");
      localStorage.removeItem("adminmenu");
    }
    if (index === 3) {
      localStorage.removeItem("supermenu");
      localStorage.removeItem("adminmenu");
    }
    if (index === 4) {
      localStorage.removeItem("supermenu");
      localStorage.removeItem("tmdmenu");
    }
  };
  /**
   * @method
   * @name  onsupermenu
   * @description ""
   */
  public onsupermenu = (index: number) => (event: any): void => {
    const supermenu: any = [];
    const Leng: number = this.state.supermenu.length;
    for (let i = 0; i < Leng; i++) {
      supermenu.push(false);
    }
    supermenu[index] = true;
    {
      /** Localstorage */
    }
    localStorage.setItem("supermenu", supermenu);
  };
  /**
   * @method
   * @name  ontmdmenu
   * @description ""
   */
  public ontmdmenu = (index: number) => (event: any): void => {
    const tmdmenu: any = [];
    const Leng: number = this.state.tmdmenu.length;
    for (let i = 0; i < Leng; i++) {
      tmdmenu.push(false);
    }
    tmdmenu[index] = true;

    {
      /** Localstorage */
    }
    localStorage.setItem("tmdmenu", tmdmenu);
  };
  /**
   * @method
   * @name  onadminmenu
   * @description ""
   */
  public onadminmenu = (index: number) => (event: any): void => {
    const adminmenu: any = [];
    const Leng: number = this.state.adminmenu.length;

    for (let i = 0; i < Leng; i++) {
      adminmenu.push(false);
    }

    adminmenu[index] = true;

    {
      /** Localstorage */
    }
    localStorage.setItem("adminmenu", adminmenu);
  };
  /**
   * @method
   * @name  onslidemenu
   * @description ""
   */
  public onslidemenu = (event: any): void => {
    Utils.hideShowmenu(); // , "with-4-columns";
    // vérification de l'existence de la variable
    if (this.props.incidentPerRow) {
      const menuClassName: any = localStorage.getItem("columns");
      {
        /** comparaison */
      }
      if (menuClassName === "with-4-columns") {
        // changement du nombre d'incidents par ligne
        this.props.onChangeItemPerRow(4); // action
      } else {
        // changement du nombre d'incidents par ligne
        this.props.onChangeItemPerRow(3);
      }
    }
  };
  /**
   * @method
   * @name  onPlayBip
   * @description " onPlayBip permet de jouer le bip pour indiquer l'existance d'au moins un incident non qualid-fié"
   */
  public onPlayBip = (audio: boolean, audioLink: string): void => {
    //  const audioBip : any = new Audio(audioLink);
    // const bell = new UIfx(audioLink);
    const bell = new Audio(audioLink);
    if (bell !== undefined) {
      // playback
      const bellpromise: any = bell.play();
      if (bellpromise !== undefined) {
        bellpromise
          .then(() => {
            bell.play();
          })
          .catch(() => {
            // window.location.reload(true);  //@TO_REMOVE
          });
      }
    }
  };

  /**
   * MAJ des onglets
   * @public
   * @method
   * @name onCheckTMDEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onCheckTMDEvent = (): void => {
    const visProp = Utils.getHiddenProp();
    if (document[visProp]) {
      SetInterval.clear("bip-tmd");
    } else {
      // callback function
      const callbackfunction = () => {
        this.props.IncidentstmdLoadedAction().then((t: any) => {
          if (t === true) {
            this.onPlayBip(true, "/audio/tmd_incident_.mp3");
          }
        });
      };
      SetInterval.start(callbackfunction, 7000, "bip-tmd");
    }
  };

  /**
   * MAJ des onglets
   * @public
   * @method
   * @name onCheckDAIINCIDENTSEventBip
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onCheckDAIINCIDENTSEventBip = (): void => {
    const visProp = Utils.getHiddenProp();
    if (document[visProp]) {
      SetInterval.clear("bip-dai");
    } else {
      // callback function
      const callbackfunction = () => {
        this.props.CheckIncidentsIsNotQualifyActionCreator().then(() => {
          if (!Lodash.isUndefined(this.props.checkIncidentisnotqualify)) {
            if (this.props.checkIncidentisnotqualify) {
              this.onPlayBip(true, "/audio/all_incidents.mp3");
            }
          }
        });
      };
      SetInterval.start(callbackfunction, 10000, "bip-dai");
    }
  };
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name onCheckDAIINCIDENTSEventNumbers
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onCheckDAIINCIDENTSEventNumbers = (): void => {
    const visProp = Utils.getHiddenProp();
    if (document[visProp]) {
      SetInterval.clear("number-dai");
    } else {
      // callback function
      const callbackfunction = () => {
        this.props.NotificationLoadedActionCreator();
      };

      SetInterval.start(callbackfunction, 1000, "number-dai");
    }
  };
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name allCallEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public allCallEvent = (callback: any): void => {
    {
      /** Handle page visibility change */
    }

    if (document.addEventListener) {
      /**
       * @constant
       * @name visProp
       * @type any
       */
      const visProp: any = Utils.getHiddenProp();
      /**
       * @constant
       * @name evtName
       * @type any
       */
      const evtName: any =
        visProp.replace(/[H|h]idden/, "") + "visibilitychange";

      document.addEventListener(evtName, callback, false);
    }
    {
      /** initialisation de la requetes: vérification des incidents */
    }
    callback();
  };
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name removeEvent
   * @param { void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public removeEvent = (callback: any): void => {
    {
      /** Empêcher la mutation du state */
    }

    /**
     * @constant
     * @name visProp
     * @type any
     */
    const visProp: any = Utils.getHiddenProp();
    /**
     * @constant
     * @name evtName
     * @type any
     */
    const evtName: any = visProp.replace(/[H|h]idden/, "") + "visibilitychange";

    {
      /** suppression de l'event */
    }
    document.removeEventListener(evtName, callback);
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      if (
        !Lodash.isEmpty(nextProps.data) &&
        !Lodash.isUndefined(nextProps.data)
      ) {
        localStorage.setItem("tmdnumbersincident", nextProps.data.length);
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          tmdnumbersincident: nextProps.data.length,
        }));
      } else {
        localStorage.setItem("tmdnumbersincident", nextProps.data.length);
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ tmdnumbersincident: 0 }));
      }
    } else if (nextProps.numberdata !== this.props.numberdata) {
      if (nextProps.numberdata && nextProps.numberdata.totalElements > 0) {
        localStorage.setItem(
          "incidentnotifications",
          nextProps.numberdata.totalElements
        );
        this.setState((state: any): any => ({
          incidentnotifications: nextProps.numberdata.totalElements,
        }));
      } else {
        localStorage.setItem("incidentnotifications", "0");
        this.setState((state: any): any => ({ incidentnotifications: 0 }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.props.IncidentstmdLoadedActionCreator(); // Call all TMD Incidents
    // this.props.NotificationLoadedActionCreator(); // Call all DAi incidents Numbers

    const tmdnumbersincident: any = localStorage.getItem("tmdnumbersincident");
    const incidentnotifications: any = localStorage.getItem(
      "incidentnotifications"
    );

    if (tmdnumbersincident !== null) {
      this.setState((state: any): any => ({ tmdnumbersincident }));
    }
    if (incidentnotifications !== null) {
      this.setState((state: any): any => ({ incidentnotifications }));
    }

    this.allCallEvent(this.onCheckTMDEvent); /// call TMD incidents every 10 secondes
    this.allCallEvent(this.onCheckDAIINCIDENTSEventBip); /// call Bip DAI incidents every 10 secondes
    this.allCallEvent(this.onCheckDAIINCIDENTSEventNumbers); /// call Bip DAI incidents every 10 secondes

    // get active menu
    const menu: any = localStorage.getItem("menus");
    const supermenu: any = localStorage.getItem("supermenu");
    const tmdmenu: any = localStorage.getItem("tmdmenu");
    const adminmenu: any = localStorage.getItem("adminmenu");

    const Location: any[] = location.href.split("/"); // gestion des Urls
    const paramMenuTunnel: boolean = Utils.transformObjectToArray(
      Location
    ).includes(Paths.PathsNamesEnums.TUNNELWATCH$);
    const paramMenuExplore: boolean = Utils.transformObjectToArray(
      Location
    ).includes(Paths.PathsNamesEnums.EXPLORE$);
    const paramSubMenuCamera: boolean = Utils.transformObjectToArray(
      Location
    ).includes(Paths.PathsNamesEnums.CAMERA$);

    if (!paramMenuTunnel && !paramMenuExplore) {
      if (adminmenu !== null) {
        const adminmenuparse: any[] = [];
        const adminmenusplit: any[] = adminmenu.split(",");
        const adminmenulength: number = adminmenusplit.length;
        for (let i = 0; i < adminmenulength; i++) {
          if (adminmenusplit[i] === "false") {
            adminmenuparse.push(false);
          } else {
            adminmenuparse.push(true);
          }
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ adminmenu: adminmenuparse }));
      }
      if (menu !== null) {
        const menuparse: any[] = [];
        const menusplit: any[] = menu.split(",");
        const menulength: number = menusplit.length;
        for (let i = 0; i < menulength; i++) {
          if (menusplit[i] === "false") {
            menuparse.push(false);
          } else {
            menuparse.push(true);
          }
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ menu: menuparse }));
      }
      if (!paramSubMenuCamera) {
        if (supermenu !== null) {
          const supermenuparse: any[] = [];
          const supermenusplit: any[] = supermenu.split(",");
          const supermenulength: number = supermenusplit.length;
          for (let i = 0; i < supermenulength; i++) {
            if (supermenusplit[i] === "false") {
              supermenuparse.push(false);
            } else {
              supermenuparse.push(true);
            }
          }
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ supermenu: supermenuparse }));
        }
      } else {
        localStorage.removeItem("supermenu");
        localStorage.setItem(
          "supermenu",
          "[false,false,false,true,false,false]"
        );
        this.setState((state: any) => ({
          supermenu: [false, false, false, true, false, false],
        }));
      }

      if (tmdmenu !== null) {
        const tmdmenuparse: any[] = [];
        const tmdmenusplit: any[] = tmdmenu.split(",");
        const tmdmenulength: number = tmdmenusplit.length;
        for (let i = 0; i < tmdmenulength; i++) {
          if (tmdmenusplit[i] === "false") {
            tmdmenuparse.push(false);
          } else {
            tmdmenuparse.push(true);
          }
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ tmdmenu: tmdmenuparse }));
      }
    }
    if (paramMenuTunnel) {
      localStorage.removeItem("supermenu");
      localStorage.removeItem("tmdmenu");
      localStorage.removeItem("adminmenu");
      localStorage.setItem("menus", "[true,false,false,false,false]");
      this.setState((state: any) => ({
        menu: [true, false, false, false, false],
      }));
    }
    if (paramMenuExplore) {
      localStorage.removeItem("supermenu");
      localStorage.removeItem("tmdmenu");
      localStorage.removeItem("adminmenu");
      localStorage.setItem("menus", "[false,true,false,false,false]");
      this.setState((state: any) => ({
        menu: [false, true, false, false, false],
      }));
    }

    {
      /** Vérification de l'existence de la variable */
    }
    if (this.props.incidentPerRow) {
      // la clé de la position du menu
      const menuClassName: any = localStorage.getItem("columns");
      {
        /** comparaison */
      }
      if (menuClassName === "with-4-columns") {
        // changement du nombre d'incidents par ligne
        this.props.onChangeItemPerRow(4); // action
      } else {
        // changement du nombre d'incidents par ligne
        this.props.onChangeItemPerRow(3);
      }
    }
    // la clé de la position du menu
    const menuClass: any = localStorage.getItem("menu");

    if (menuClass !== null) {
      if (menuClass === "menuRight") {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ menuSlide: true }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ menuSlide: false }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillMount() {
    // Stopper l'arlame
    this.removeEvent(this.onCheckTMDEvent);
    this.removeEvent(this.onCheckDAIINCIDENTSEventBip);
    this.removeEvent(this.onCheckDAIINCIDENTSEventNumbers);

    SetInterval.clear("bip");
    SetInterval.clear("bip-dai");
    SetInterval.clear("number-dai");
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.state}
        {...this.props}
        onmenu={this.onmenu}
        onsupermenu={this.onsupermenu}
        ontmdmenu={this.ontmdmenu}
        onadminmenu={this.onadminmenu}
        onslidemenu={this.onslidemenu}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.IncidentstmdLoaded.data,
    checkIncidentisnotqualify: state.CheckIncidentsIsNotQualify.data,
    numberdata: state.NotificationLoaded.data,
    error: state.IncidentstmdLoaded.error,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  CheckIncidentsIsNotQualifyActionCreator,
  IncidentstmdLoadedActionCreator,
  NotificationLoadedActionCreator,
  IncidentstmdLoadedAction,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/menu/container.tsx